var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14634 1.21408L10 8.06751L16.8255 1.24228C17.0672 0.985068 17.4032 0.837423 17.7562 0.833333C18.5351 0.833333 19.1664 1.46467 19.1664 2.2435C19.1731 2.59294 19.0353 2.92969 18.7857 3.17422L11.8897 9.99944L18.7857 16.8952C19.0181 17.1225 19.1545 17.4305 19.1664 17.7554C19.1664 18.5342 18.5351 19.1655 17.7562 19.1655C17.3928 19.1806 17.0398 19.0424 16.7832 18.7848L10 11.9314L3.16044 18.7707C2.91971 19.0193 2.58972 19.1615 2.24379 19.1655C1.46493 19.1655 0.833572 18.5342 0.833572 17.7554C0.826944 17.4059 0.964723 17.0692 1.21433 16.8247L8.11031 9.99944L1.21433 3.10371C0.981927 2.87639 0.845559 2.56841 0.833572 2.2435C0.833572 1.46467 1.46493 0.833333 2.24379 0.833333C2.58281 0.837423 2.90674 0.974068 3.14634 1.21408Z",
    fill: "#EB3223"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.a5a38dd00416622ff7cc5197d4cae410.svg";
export { ForwardRef as ReactComponent };